import * as React from 'react';
// @ts-ignore
import { Nav } from './Nav';

export function NavBar() {
  return (
    <>
      <Nav />
    </>
  );
}
